import { AlbumWidget } from "../../";
import { roofingPhotoSections } from "../../../constants/inspectionPhotos";

interface InspectionPhotosProps {
    taskId: string;
    projectId: string;
}

export function InspectionPhotos(props: InspectionPhotosProps) {
    const { taskId, projectId } = props;
    return (
        <AlbumWidget
            sections={roofingPhotoSections}
            taskId={taskId}
            projectId={projectId}
            assetType="TASK:INITIAL_INSPECTION"
            heading="Inspection Photos"
            subheading="Please upload the required photos for each category below to complete the initial inspection."
        />
    );
}
